const H = (A) => !A || A && Object.values(A).findIndex((_) => typeof _ != "boolean" && Boolean(_)) === -1, E = 0.5, O = 0.8, D = 768;
var T = /* @__PURE__ */ ((A) => (A[A.HAVE_NOTHING = 0] = "HAVE_NOTHING", A[A.HAVE_METADATA = 1] = "HAVE_METADATA", A[A.HAVE_CURRENT_DATA = 2] = "HAVE_CURRENT_DATA", A[A.HAVE_FUTURE_DATA = 3] = "HAVE_FUTURE_DATA", A[A.HAVE_ENOUGH_DATA = 4] = "HAVE_ENOUGH_DATA", A))(T || {});
export {
  D as DEFAULT_SCREEN_BREAKPOINT,
  T as EVideoReadyState,
  E as LOOP_THRESHOLD,
  O as NO_LOOP_THRESHOLD,
  H as isPcSameM
};
//# sourceMappingURL=const.mjs.map
